export const OrdersIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 18.125C6.25 18.4565 6.1183 18.7745 5.88388 19.0089C5.64946 19.2433 5.33152 19.375 5 19.375C4.66848 19.375 4.35054 19.2433 4.11612 19.0089C3.8817 18.7745 3.75 18.4565 3.75 18.125C3.75 17.7935 3.8817 17.4755 4.11612 17.2411C4.35054 17.0067 4.66848 16.875 5 16.875C5.33152 16.875 5.64946 17.0067 5.88388 17.2411C6.1183 17.4755 6.25 17.7935 6.25 18.125Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.125 18.125C18.125 18.4565 17.9933 18.7745 17.7589 19.0089C17.5245 19.2433 17.2065 19.375 16.875 19.375C16.5435 19.375 16.2255 19.2433 15.9911 19.0089C15.7567 18.7745 15.625 18.4565 15.625 18.125C15.625 17.7935 15.7567 17.4755 15.9911 17.2411C16.2255 17.0067 16.5435 16.875 16.875 16.875C17.2065 16.875 17.5245 17.0067 17.7589 17.2411C17.9933 17.4755 18.125 17.7935 18.125 18.125Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.375 15H6.1C5.7956 15.0004 5.50151 14.8898 5.27291 14.6888C5.0443 14.4878 4.89689 14.2103 4.85833 13.9083L3.26667 1.71667C3.22811 1.41472 3.0807 1.13722 2.85209 0.936233C2.62349 0.735244 2.3294 0.624579 2.025 0.625001H0.625"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 3.125H8.75C8.75 3.125 7.5 3.125 7.5 4.375V11.25C7.5 11.25 7.5 12.5 8.75 12.5H16.25C16.25 12.5 17.5 12.5 17.5 11.25V4.375C17.5 4.375 17.5 3.125 16.25 3.125Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0413 7.29167H13.958V3.125H11.0413V7.29167Z"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
